import React from 'react'; 
import { CgCPlusPlus } from "react-icons/cg";
import {FaReact, FaPython, FaGitAlt, FaGithub, FaNpm, FaFigma, FaBootstrap, FaJava} from "react-icons/fa";
import {DiNodejs, DiJavascript1} from "react-icons/di";
import {SiRstudio , SiMongodb, SiPostman, SiVercel, SiDocker} from "react-icons/si";
import { TiHtml5 } from "react-icons/ti";


const Skills = ({skill}) => {
    const icon = {
        'C++': <CgCPlusPlus/>,
        Python: <FaPython/>,
        Java: <FaJava/>,
        Postman: <SiPostman/>,
        React: <FaReact/>,
        RStudio: <SiRstudio/>,
        Javascript: <DiJavascript1/>,
        Node : <DiNodejs/>,
        MongoDb : <SiMongodb/>,
        Git : <FaGitAlt/>,
        Github : <FaGithub/>,
        Npm : <FaNpm/>,
        Figma : <FaFigma/>,
        Bootstrap: <FaBootstrap/>,
        Vercel : <SiVercel/>,
        HTML : <TiHtml5/>,
        Docker : <SiDocker />
    }
    
  return (
    <div title={skill} className='SkillBox'>
      {icon[skill]}
    </div>
  )
}

export default Skills
